export default {
      id: "action-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#action-usage",
      toString: function () {
        return this.url;
      }
    }